/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */

export type UserTypeEnum = typeof UserTypeEnum[keyof typeof UserTypeEnum];


export const UserTypeEnum = {
  User: 'User',
  Pupil: 'Pupil',
  Visitor: 'Visitor',
  LoggedOutUser: 'LoggedOutUser',
} as const;
